module.exports = __webpack_public_path__ + "img/icon_nav-hamburger.bc5bcae0.svg";